module.exports = __webpack_public_path__ + "static/media/68.ba95ac7f.jpg";